<template>
  <section class="section-4 alpha-section wrapper">
    <div class="hd hd-flip">
      <h2 class="title">
        学习日程
      </h2>
    </div>

    <div class="content">
      <div class="content-hd">
        <h5>教学大纲</h5>
        <p>TTPS-Alpha线下课程，专注于传授TTPS交易系统下的九大交易策略。四天五夜，专为交易员的实战体验私人定制！</p>
      </div>

      <div class="content-bd">
        <div />
        <div />
        <div />
        <div />
      </div>
      <div class="content-ft">
        <label>本期【TTPS交易系统】线下课程时间为：</label><span>2021年7月7日-7月10日</span>(预约
        <span
          style="cursor: pointer"
          @click="openDialog"
        >
          其他上课时间
        </span>)
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  methods: {
    openDialog() {
      // eslint-disable-next-line no-underscore-dangle
      (window._czc || []).push(['_trackEvent', 'B页-学习日程-预约咨询', 'click', window.location.href]);

      this.$store.dispatch('changeContactVisible', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.section-4 {
  padding-top: percentage(148px / $deviceWidth);
  padding-bottom: percentage(84px / $deviceWidth);
  background: url("~assets/class-bg.png") center/cover no-repeat;
  @include hdpi() {
    background-image: url("~assets/class-bg@2x.png");
  }

  &.active {
    .content {
      &-hd {
        animation: fadeInUp .2s 1s ease-out both;
      }
      &-bd {
        div {
          animation: fadeInUp .4s 1s ease-out both;
        }
        @for $i from 1 through 4 {
          div {
            &:nth-of-type(#{$i}) {
              animation-delay: #{$i * 0.2s + 0.6s};
            }
          }
        }
      }
    }
  }

  .title {
    margin-right: percentage(218px / $deviceWidth);
    width: percentage(339px / $deviceWidth);
    padding-top: percentage(145px / $deviceWidth);
  }

  .content {
    $contentWidth: 1440px;
    margin: percentage(86px / $deviceWidth) auto 0;
    width: percentage($contentWidth / $deviceWidth);
    text-align: left;

    &-hd {
      opacity: 0;
      h5 {
        margin: 0;
        font-size: 36px;
        color: #fff;
        line-height: 40px;
      }

      p {
        margin: percentage(34px / $contentWidth) 0 0;
        font-size: 20px;
        line-height: 24px;
        color: #fff;
        opacity: .8;
      }
    }

    &-bd {
      margin: percentage(144px / $contentWidth) auto 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;

      @for $i from 1 through 4 {
        div {
          &:nth-of-type(#{$i}) {
            background: url("~assets/class-#{$i}.png") center top/contain no-repeat;
            @include hdpi() {
              background-image: url("~assets/class-#{$i}@2x.png");
            }
          }
        }
      }

      div {
        opacity: 0;
        margin-bottom: percentage(100px / $contentWidth);
        &:nth-of-type(1) {
          width: percentage(701px / $contentWidth);
          padding-top: percentage(321px / $contentWidth);
        }
        &:nth-of-type(2) {
          width: percentage(671px / $contentWidth);
          padding-top: percentage(386px / $contentWidth);
        }
        &:nth-of-type(3) {
          width: percentage(676px / $contentWidth);
          padding-top: percentage(317px / $contentWidth);
        }
        &:nth-of-type(4) {
          width: percentage(675px / $contentWidth);
          padding-top: percentage(316px / $contentWidth);
        }
      }
    }

    &-ft {
      width: percentage(1224px / $contentWidth);
      margin: 0 auto;
      padding: 26px;
      line-height: 28px;
      font-size: 24px;
      color: #fff;
      font-weight: 600;
      background-color: #305EE0;
      border-radius: 8px;
      text-align: center;

      span {
        color: #FFD36B;

        &:nth-of-type(2) {
          position: relative;
          cursor: pointer;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: #FFD36B;
          }
        }
      }
    }
  }

  @include mediaWidth(1680px) {
    .content {
      &-ft {
        width: auto;
      }
    }
  }

  @include mediaWidth(1440px) {
    .content {
      &-hd {
        h5 {
          font-size: 32px;
        }

        p {
          font-size: 18px;
        }
      }
      &-ft {
        padding: 16px;
        font-size: 18px;
      }
    }
  }

  @include mediaWidth(1024px) {
    .content {
      &-ft {
        width: auto;
        padding: 16px;
        font-size: 18px;
      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    padding-top: percentage(70px / $mbWidth);
    padding-bottom: percentage(50px / $mbWidth);
    background: url("~assets/class-bg-m.png") center/cover no-repeat;
    @include hdpi() {
      background-image: url("~assets/class-bg-m@2x.png");
    }

    .title {
      width: percentage(210px / $mbWidth);
      padding-top: percentage(90px / $mbWidth);
    }

    .content {
      width: percentage(680px / $mbWidth);
      &-hd {
        h5 {
          font-size: 20px;
        }

        p {
          font-size: 16px;
        }
      }
      &-bd {
        display: block;
        div {
          width: 100% !important;
          margin-bottom: percentage(48px / 680px);

          &:nth-of-type(1) {
            padding-top: percentage(237px / 680px);
          }
          &:nth-of-type(2), &:nth-of-type(3) {
            padding-top: percentage(283px / 680px);
          }
          &:nth-of-type(4) {
            padding-top: percentage(200px / 680px);
          }
        }

        @for $i from 1 through 4 {
          div {
            &:nth-of-type(#{$i}) {
              background: url("~assets/class-#{$i}-m.png") center/contain no-repeat;
              @include hdpi() {
                background-image: url("~assets/class-#{$i}-m@2x.png");
              }
            }
          }
        }
      }
      &-ft {
        padding: 12px percentage(80px / $mbWidth);
        line-height: 24px;
        text-align: center;
        label {
          display: block;
        }
      }
    }
  }

  @include mediaWidth(528px) {
    .content {
      &-hd {
        p {
          font-size: 12px;
          line-height: 20px;
        }
      }
      &-ft {
        padding: 12px 0;
        font-size: 14px;
      }
    }
  }
}
</style>
